import styled from "styled-components";

export const MusicHallSettingContainerStyled = styled.div``;
